var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Injectable } from '@angular/core';
import { Store } from '../data/store';
import { InventoryManager } from './inventory-manager';
import { OpeningHours } from '../data/opening-hours';
import { Period } from '../data/period';
var MenuManager = /** @class */ (function () {
    function MenuManager(inventoryManager) {
        this.inventoryManager = inventoryManager;
        this.showAllCats = false; //a flag in kiosk debug settings showing all categories in any cases
        this.availableMap = {}; //items' available map
        this.debug = false;
        this.legacy = false;
    }
    MenuManager_1 = MenuManager;
    //returns the current time or debug time
    MenuManager.prototype.getTime = function (store) {
        if (store === void 0) { store = null; }
        if (this.debugTime)
            return this.debugTime;
        var now = this.convertNowDateToStoreTimeZone(store.timezone).getTime();
        return now;
    };
    MenuManager.prototype.convertNowDateToStoreTimeZone = function (timeZone) {
        timeZone = timeZone ? timeZone : 'GMT+8';
        var timeZoneValue = timeZone.split('GMT')[1];
        // let isPositive = timeZoneValue.startsWith('+');
        var integerTimeZoneValue = parseInt(timeZoneValue);
        var now = new Date();
        now.setHours(now.getUTCHours() + integerTimeZoneValue);
        return now;
    };
    MenuManager.prototype.setDebugTime = function (time) {
        this.debugTime = time;
    };
    //available map id format
    MenuManager.prototype.getAvailableMapId = function (catId, itemId) {
        if (catId === void 0) { catId = ""; }
        if (itemId === void 0) { itemId = ""; }
        return catId + "-" + itemId;
    };
    MenuManager.prototype.clearAvailableMap = function () {
        this.availableMap = {};
    };
    /*
    getAvailableCategories(store: Store, now: number, takeout:boolean = false): Category[] {



        var menu = store.menu;

        //let showAllCats = this.prefService.getBoolean("debug.show-all-categories", false);
        //let period: string = this.prefService.get("kiosk.period", "auto");


        let categories: Category[] = store.menu.getAvailableCategories(store, showAllCats, period, now);

        let inv: boolean = this.prefService.getBoolean("kiosk.enable-inventory", true);

        let result: Category[] = [];

        categories.forEach(cat => {

            let mainIg: ItemGroup = cat.groups[0];

            let mainItems: Item[] = [];
            mainIg.items.forEach(item => {

                if (this.invManager.isPublish(item) && this.isBetween(item, now)) {
                    mainItems.push(item);
                }

            })

            if(takeout){
                mainItems = mainItems.filter(i => { return !i.dinein });
            }

            if (mainItems.length > 0) {

                for (let item of mainItems) {


                    let soldout: boolean = false;

                    for (let group of item.groups) {

                        let publishs: number = 0;

                        group.items.forEach(item => {

                            if (this.invManager.isPublish(item) && this.isBetween(item, now)) {
                                publishs++;
                            }
                        });

                        let min = group.min;
                        let valid: boolean = true;

                        if (group.repeat) {
                            valid = publishs > 0;
                        } else {
                            valid = publishs >= min;
                        }


                        if (!valid) {

                            soldout = true;
                            break;
                        }
                    }

                    if (item.groups.length == 0) {
                        item.combo = false;
                    }

                    if (soldout && inv) {
                        this.invManager.soldout(item);
                    }

                }

                result.push(cat);

            }

        });

        return result;
    }

*/
    MenuManager.prototype.log = function (tag) {
        var others = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            others[_i - 1] = arguments[_i];
        }
        if (!this.debug)
            return;
        console.log(tag, others);
    };
    /**Get available recommendation category**/
    MenuManager.prototype.getAvailableRecommendation = function (store, now, takeout) {
        if (now === void 0) { now = this.getTime(store); }
        if (!store || !store.menu) {
            return null;
        }
        var storeOpen = Store.isOpeningHours(store, now);
        if (!storeOpen)
            return null;
        if (!store || !store.menu) {
            return null;
        }
        var recommendation = store.menu.recommendation;
        if (!recommendation)
            return null;
        if (this.isAvailableCategory(store, recommendation, takeout, false)) {
            return recommendation;
        }
        return null;
    };
    /**Get available gift categories**/
    MenuManager.prototype.getAvailableGifts = function (store, now, takeout) {
        var _this = this;
        if (now === void 0) { now = this.getTime(store); }
        if (!store || !store.menu) {
            return null;
        }
        var storeOpen = Store.isOpeningHours(store, now);
        if (!storeOpen)
            return null;
        if (!store || !store.menu) {
            return null;
        }
        var gifts = store.menu.gifts;
        if (!gifts)
            return null;
        var result = [];
        gifts.forEach(function (u) {
            if (_this.isAvailableCategory(store, u, takeout, false)) {
                result.push(u);
            }
        });
        return result;
    };
    /**Get available unlock categories**/
    MenuManager.prototype.getAvailableUnlocks = function (store, now, takeout) {
        var _this = this;
        if (now === void 0) { now = this.getTime(store); }
        if (!store || !store.menu) {
            return null;
        }
        var storeOpen = Store.isOpeningHours(store, now);
        if (!storeOpen)
            return null;
        if (!store || !store.menu) {
            return null;
        }
        var unlocks = store.menu.unlocks;
        if (!unlocks)
            return null;
        var result = [];
        unlocks.forEach(function (u) {
            if (_this.isAvailableCategory(store, u, takeout, false)) {
                result.push(u);
            }
        });
        return result;
    };
    /**Get category's available main items(in main group)**/
    MenuManager.prototype.getAvailableMainItems = function (store, category, takeout, pickupTime) {
        var mainIg = category.groups[0];
        if (!mainIg)
            return [];
        return this.getAvailableItems(store, category, mainIg, takeout, pickupTime);
    };
    /**
     * Get availble main items(parent items) in the very group
     * Get parent items available variations
     *  **/
    MenuManager.prototype.getAvailableItems = function (store, category, ig, takeout, pickupTime) {
        var _this = this;
        var now = this.getTime(store);
        var time = pickupTime ? pickupTime : now;
        var items = ig.parentItems;
        if (!items)
            return [];
        var result = [];
        var _loop_1 = function (item) {
            if (!this_1.isAvailableItem(store, category, ig, item, takeout, time)) {
                if (item.variations && item.variations.length > 0) {
                    item.variations.forEach(function (v) {
                        if (_this.isAvailableItem(store, category, ig, v, takeout, time))
                            result.push(v);
                    });
                }
                return "continue";
            }
            if (item.variations && item.variations.length > 0) {
                var variation_1 = [];
                item.variations.forEach(function (v) {
                    if (_this.isAvailableItem(store, category, ig, v, takeout, time))
                        variation_1.push(v);
                });
                item.variations = variation_1;
            }
            result.push(item);
        };
        var this_1 = this;
        for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
            var item = items_1[_i];
            _loop_1(item);
        }
        if (result.length != items.length) {
            this.log("filtered main items", category.name, items.length + "->" + result.length);
        }
        return result;
    };
    /**
     * Check if item is available, according to rules:
     * 1. dinein-takeout mode
     * 2. inventory
     * 3. available time slots or periods
     * 4. published or not
     * 5. todo: has available required modifiers
     * **/
    MenuManager.prototype.isAvailableItem = function (store, category, ig, item, takeout, now) {
        if (!MenuManager_1.staticMenuMapForOh[store.id]) {
            MenuManager_1.staticMenuMapForOh[store.id] = store.menu;
        }
        if (this.showAllCats)
            return true;
        if (item.suspended)
            return false;
        if (item.ohId) {
            var brandOh = null;
            if (store.brand) {
                brandOh = store.brand.openings;
            }
            if (store.menu && store.menu.itemOpenings) {
                var ohMap = store.menu.itemOpenings;
                if (ohMap[item.ohId]) {
                    var itemOhMap = ohMap[item.ohId];
                    var itemOpenings = (MenuManager_1.staticMenuMapForOh[store.id] && MenuManager_1.staticMenuMapForOh[store.id].itemOpenings[item.ohId]) || {};
                    if (!itemOpenings["ohResult"]) {
                        console.log("call check isTimeOpen", item);
                        if (!OpeningHours.isTimeOpen(brandOh, itemOhMap, now)) {
                            this.log("item openings not available", category.name);
                            itemOpenings["ohResult"] = 1;
                            MenuManager_1.staticMenuMapForOh[store.id].itemOpenings[item.ohId] = itemOpenings;
                            return false;
                        }
                        itemOpenings["ohResult"] = 2;
                        MenuManager_1.staticMenuMapForOh[store.id].itemOpenings[item.ohId] = itemOpenings;
                    }
                    else if (MenuManager_1.staticMenuMapForOh[store.id].itemOpenings[item.ohId] && MenuManager_1.staticMenuMapForOh[store.id].itemOpenings[item.ohId]["ohResult"] == 2) {
                        // is ok
                    }
                    else {
                        return false;
                    }
                }
            }
        }
        else {
            //if category time not valid, don't show it
            if (!this.isAvailabeByStartEnd(item, now)) {
                this.log("item time not available", item.name);
                return false;
            }
            // if (!this.isAvailabeByPeriods(store, category.periods, now)) {
            //     this.log("cat period not available2", category.name);
            //     return false;
            // }
        }
        //TODO: add item to availableMap??
        //check dinein/takeout mode, *ignore delivery mode in kiosk
        if (!this.isAvailablebyModes(item, takeout)) {
            this.log("item mode filter", item.name, item.modes);
            return false;
        }
        //skip dinein only items DEPRECATED
        /*if (takeout && item.dinein){
            this.log("dine in filter", item.name);
            return false;
        }*/
        //skip items with inventory -1000
        if (this.inventoryManager.isHidden(item)) {
            this.log("inv hidden", item.name);
            return false;
        }
        //check if item have start end time
        if (!this.isAvailabeByStartEnd(item, now)) {
            this.log("start end filter", item.name);
            return false;
        }
        if (!this.isAvailabeByPeriods(store, item.periods, now)) {
            this.log("periods filter", item.name);
            return false;
        }
        if (!this.isItemPublished(category, ig, item)) {
            this.log("cay pub filter", item.name);
            return false;
        }
        return true;
    };
    MenuManager.prototype.isAvailabeByStartEnd = function (item, now) {
        if (!item.start && !item.end)
            return true;
        var greaterThanStart = true;
        var lessThanEnd = true;
        if (item.start) {
            greaterThanStart = now >= item.start;
        }
        if (item.end) {
            lessThanEnd = now <= item.end;
        }
        return greaterThanStart && lessThanEnd;
    };
    /**
     * Check if it is an available item group/ modifier group
     * @param modifier: if it is a modifier group
     **/
    MenuManager.prototype.isAvailableGroup = function (store, cat, group, takeout, now, modifier) {
        if (modifier && group.min == 0)
            return true;
        var publishs = 0;
        var valid = true;
        if (group.items && group.items.length > 0) {
            for (var _i = 0, _a = group.items; _i < _a.length; _i++) {
                var item = _a[_i];
                valid = true;
                if (item.mgroups) {
                    for (var _b = 0, _c = item.mgroups; _b < _c.length; _b++) {
                        var mgroup = _c[_b];
                        if (!this.isAvailableGroup(store, cat, mgroup, takeout, now, true)) {
                            valid = false;
                            this.log("isn't available modifier group", cat.name, mgroup.name);
                            break;
                        }
                    }
                    if (!valid) {
                        continue;
                    }
                }
                //if(!valid) break;
                if (!this.inventoryManager.isSoldout(item) && this.isAvailableItem(store, cat, group, item, takeout, now)) {
                    publishs++;
                }
            }
            ;
        }
        //if(!valid) return false;
        var min = group.min;
        if (group.repeat) {
            //valid = publishs > 0;
            if (min == 0) {
                valid = true;
            }
            else {
                valid = publishs > 0;
            }
        }
        else {
            valid = publishs >= min;
        }
        return valid;
    };
    /**
     * Check if it is an available combo, by checking:
     * TODO: if main item is available;
     * and if subgroups are all available.
     * store availability status in availableMap
     * **/
    MenuManager.prototype.isAvailableCombo = function (store, cat, mainItem, takeout, now) {
        var mapId = this.getAvailableMapId(cat.id, mainItem.id);
        if (typeof this.availableMap[mapId] != "undefined")
            return this.availableMap[mapId];
        var catgroups = cat.groups;
        if (!catgroups)
            catgroups = [];
        var mainItemGroups = mainItem.groups;
        if (!mainItemGroups)
            mainItemGroups = [];
        var groups = catgroups.concat(mainItemGroups);
        var isAvailable = true;
        for (var _i = 0, groups_1 = groups; _i < groups_1.length; _i++) {
            var group = groups_1[_i];
            if (!this.isAvailableGroup(store, cat, group, takeout, now, false)) {
                isAvailable = false;
                this.log("isn't available group", cat.name, group.name);
                break;
            }
        }
        this.availableMap[mapId] = isAvailable;
        return isAvailable;
    };
    /**
     * Check if it is an available category, determinded by rules:
     * 1. category is suspended / published or not
     * 2. if category's mode is the same as order dinein/takeout mode
     * 3. category's available time slots or period
     * 4. if category has main items
     * **/
    MenuManager.prototype.isAvailableCategory = function (store, category, takeout, checkPublish, time, isMember) {
        if (this.showAllCats)
            return true;
        //if not published, don't show it
        if (category.suspended)
            return false;
        if (checkPublish && !category.published)
            return false;
        var now = time || this.getTime(store);
        if (!this.isAvailablebyModes(category, takeout)) {
            this.log("cat mode not available", category.modes);
            return false;
        }
        if (category.openings) {
            var brandOh = null;
            if (store.brand) {
                brandOh = store.brand.openings;
            }
            if (!OpeningHours.isTimeOpen(brandOh, category.openings, now)) {
                this.log("cat openings not available", category.name);
                return false;
            }
        }
        else {
            //if category time not valid, don't show it
            if (!this.isAvailabeByStartEnd(category, now)) {
                this.log("cat time not available", category.name);
                return false;
            }
            if (!this.isAvailabeByPeriods(store, category.periods, now)) {
                this.log("cat period not available2", category.name);
                return false;
            }
        }
        // member check
        if (category.users && category.users.length > -1) {
            // 目前hkAA member和staff餐单logic一样 所以这样处理 往后logic不同再修改
            if (category.users.indexOf('member') > -1) {
                if (isMember !== 'member') {
                    this.log("cat member not available", category.name);
                    return false;
                }
            }
            else if (category.users.indexOf('staff') > -1) {
                if (isMember !== 'staff') {
                    this.log("cat staff not available", category.name);
                    return false;
                }
            }
        }
        var mainItems = this.getAvailableMainItems(store, category, takeout);
        if (mainItems.length == 0) {
            return false;
        }
        return true;
    };
    /**
     * Get all available categories in the store
     * **/
    MenuManager.prototype.getAvailableCategories = function (store, now, takeout, isMember) {
        if (now === void 0) { now = this.getTime(store); }
        var result = [];
        if (!store || !store.menu) {
            return result;
        }
        var storeOpen = Store.isOpeningHours(store, now);
        if (!storeOpen)
            return result;
        var cats = store.menu.categories;
        if (!cats || cats.length == 0)
            return result;
        for (var _i = 0, cats_1 = cats; _i < cats_1.length; _i++) {
            var c = cats_1[_i];
            if (this.isAvailableCategory(store, c, takeout, true, now, isMember))
                result.push(c);
        }
        if (result.length != cats.length) {
            this.log("filtered cat", cats.length + "->" + result.length);
        }
        return result;
    };
    MenuManager.prototype.isAvailabeByPeriods = function (store, periods, now) {
        var brand = store.brand;
        if (!periods || periods.length == 0) {
            return true;
        }
        var available = false;
        if (this.periodOverwrite && this.periodOverwrite != "auto") {
            if (periods.indexOf(this.periodOverwrite) != -1)
                return true;
            else
                return false;
        }
        var _loop_2 = function (p) {
            //special case handling where cat period is a V3 cron expression
            if (p.length > 10) {
                //result.push(c);
            }
            else {
                if (store.periods) {
                    var period = store.periods.find(function (x) { return x.code == p; });
                    if (period) {
                        if (this_2.isPeriodAvailable(brand ? brand.openings : null, period, now)) {
                            available = true;
                            return "break";
                        }
                    }
                }
            }
        };
        var this_2 = this;
        //check if cat period is ok
        for (var _i = 0, periods_1 = periods; _i < periods_1.length; _i++) {
            var p = periods_1[_i];
            var state_1 = _loop_2(p);
            if (state_1 === "break")
                break;
        }
        return available;
    };
    MenuManager.prototype.isAvailablebyModes = function (item, takeout) {
        var modes = item.modes;
        if (!modes || modes.length == 0)
            return true;
        //check kiosk/mobile first
        var device = MenuManager_1.device;
        if (device) {
            if (device == "kiosk") {
                if (modes.indexOf("kiosk") == -1 && modes.indexOf("byod") >= 0) {
                    return false;
                }
            }
            else if (device == "byod") {
                if (modes.indexOf("byod") == -1 && modes.indexOf("kiosk") >= 0) {
                    return false;
                }
            }
        }
        if (modes.indexOf(takeout ? "takeaway" : "dinein") >= 0)
            return true;
        return false;
    };
    /*
    getCategories(store: Store, ignorePeriod: boolean = false, currentPeriod: string = "auto", now: number = this.getTime()): Category[] {

        var result = [];

        if (ignorePeriod) return this.filterEmptyGroup(this.categories);

        var storePeriods = this.periods;
        if (!storePeriods || storePeriods.length == 0) return this.filterEmptyGroup(this.categories);

        var periodsMap = {};
        for (let p of this.periods) {
            periodsMap[p.code] = p;
        }

        //caught old style categories' period format
       var periodCodes = ["B","L","T","D","M"];
       if(this.categories.length > 0 && this.categories[0].periods){
           if(periodCodes.indexOf(this.categories[0].periods[0]) == -1) return this.filterEmptyGroup(this.categories);

       }


        var today = new Date(now);
        today.setHours(0, 0, 0, 0);
        //this.log(today);
        let todayTime = today.getTime();
        let brand = store.brand;

        for (let c of this.categories) {

            if (!this.isBetween(c, now)) continue;
            if (!c.published) continue;

            var periods = c.periods;
            if (periods == null) {

                if (Store.isOpeningHours(store, now)) {
                    result.push(c);
                }
            } else {

                for (let p of periods) {

                    if (currentPeriod == "auto") {

                        var period = periodsMap[p];
                        if (period) {
                            if (this.isAvailable(brand.openings, period, todayTime, now)) {
                                result.push(c);
                                break;
                            }
                        }
                    } else {

                        if (periods.indexOf(currentPeriod) > -1) {
                            result.push(c);
                            break;
                        }
                    }


                }

            }

        }


        return this.filterEmptyGroup(result);
    }  */
    /*
    setupVariations(i: Item): Item {

        let result: Item = i;

        if (i.parentId) {


            let p = this.variations[i.parentId];
            let exist: boolean = typeof p !== 'undefined';

            if (exist) {

                p.items.push(i);
            }
            else {
                let items: Array<Item> = [];

                items.push(i);

                p = {

                    items: items
                };

                this.variations[i.parentId] = p;
            }

            if(i.parentId != i.id)
                result = null;
        }

        

        return result;
    }*/
    MenuManager.prototype.isPeriodAvailable = function (brandOh, period, now) {
        //this.log("is avail?", period, now);
        if (period.openings) {
            this.log("isAvailable : check by opening rules");
            var open_1 = OpeningHours.isTimeOpen(brandOh, period.openings, now);
            return open_1;
        }
        else {
            //if (!period.start || !period.end) return false;
            return Period.isTimeOpen(period, now);
        }
    };
    MenuManager.prototype.isItemPublished = function (cat, ig, item) {
        var cmap = ig.cmap;
        if (cmap && Object.keys(cmap).length > 0) {
            var catPub = cmap[cat.id];
            if (!catPub) {
                //need to check for indexed map by adding .index
                var index = cat.groupIds.indexOf(ig.id);
                if (index >= 0) {
                    catPub = cmap[cat.id + "." + index];
                }
            }
            if (catPub) {
                var published = catPub[item.id];
                if (published == false) {
                    return false;
                }
                else {
                    return true;
                }
            }
            else {
                //if menu is legacy, by default doesn't show
                if (this.legacy) {
                    return false;
                }
                else {
                    return true;
                }
            }
        }
        return item.published;
    };
    /**
     * Handle special cases in menu:
     * 1. specially handle variations
     * 2. separate recommendation/gifts/unlock categories
     * 3. find out promotion group and push into mainitems
     * 4. find out modifiers
     * 5!!!. build up groups' map, categories' map and items' map (menu.gmap, menu.cmap, menu.imap )
     * **/
    MenuManager.prototype.processMenu = function (menu, device) {
        if (device === void 0) { device = null; }
        this.legacy = menu.legacy;
        //set device source
        if (device) {
            MenuManager_1.device = device;
        }
        //if(menu.)
        var groups = menu.groups;
        if (groups && groups.length > 0) {
            var gmap = {};
            var imap = {};
            for (var _i = 0, groups_2 = groups; _i < groups_2.length; _i++) {
                var ig_1 = groups_2[_i];
                gmap[ig_1.id] = ig_1;
                for (var _a = 0, _b = ig_1.items; _a < _b.length; _a++) {
                    var i_1 = _b[_a];
                    imap[i_1.id] = i_1;
                }
                ;
                this.processVariations(ig_1);
            }
            var cmap = {};
            var cats = menu.categories.slice();
            if (menu.recommendation) {
                cats.push(menu.recommendation);
            }
            if (menu.unlocks) {
                cats = cats.concat(menu.unlocks);
            }
            if (menu.gifts) {
                cats = cats.concat(menu.gifts);
            }
            if (menu.pass) {
                cats.push(menu.pass);
            }
            for (var _c = 0, cats_2 = cats; _c < cats_2.length; _c++) {
                var cat = cats_2[_c];
                cmap[cat.id] = cat;
                var igs = [];
                var i = 0;
                for (var _d = 0, _e = cat.groupIds; _d < _e.length; _d++) {
                    var igId = _e[_d];
                    var ig = gmap[igId];
                    if (ig) {
                        igs.push(ig);
                        if (i == 0) {
                            for (var _f = 0, _g = ig.items; _f < _g.length; _f++) {
                                var item = _g[_f];
                                var subids = item.groupIds;
                                if (subids && subids.length > 0) {
                                    var subs = [];
                                    for (var _h = 0, subids_1 = subids; _h < subids_1.length; _h++) {
                                        var sgId = subids_1[_h];
                                        var sg = gmap[sgId];
                                        if (sg)
                                            subs.push(sg);
                                    }
                                    item.groups = subs;
                                    for (var _j = 0, subs_1 = subs; _j < subs_1.length; _j++) {
                                        var sig = subs_1[_j];
                                        this.log("checkingIgA", sig);
                                        this.checkIg(sig, gmap);
                                    }
                                }
                                var pgroupId = item.pgroupId;
                                if (pgroupId) {
                                    var pg = gmap[pgroupId];
                                    if (pg) {
                                        item.pgroup = pg;
                                        this.log("checkingIgB", pg);
                                        this.checkIg(pg, gmap);
                                    }
                                    else {
                                        this.log("invalid pg", item);
                                    }
                                }
                            }
                        }
                        this.log("checkingIgC", ig);
                        this.checkIg(ig, gmap);
                        i++;
                    }
                    //this.log("checking ig", ig.name);
                    //for main item group, check if main items have any groups
                }
                //this.log(cat.name, cat.groupIds, igs.length);
                cat.groups = igs;
            }
            menu['gmap'] = gmap;
            menu['cmap'] = cmap;
            menu['imap'] = imap;
        }
        return menu;
    };
    /**
     * separate varations from menu's item list,
     * and push them into their parents' parent.variations
     * **/
    MenuManager.prototype.processVariations = function (ig) {
        var items = ig.items;
        if (!items) {
            return;
        }
        var map = {};
        for (var _i = 0, items_2 = items; _i < items_2.length; _i++) {
            var item = items_2[_i];
            map[item.id] = item;
        }
        var top = [];
        //keep track of which level is each item assigned to, to break recursive parents and all items are presented someway
        var L1 = {};
        var L2 = {};
        for (var _a = 0, items_3 = items; _a < items_3.length; _a++) {
            var item = items_3[_a];
            if (item.parentId && item.parentId != item.id) {
                var parent = map[item.parentId];
                //if parent exists and parent is not in level 2
                if (parent && !L2[parent.id]) {
                    if (!parent.variations) {
                        parent.variations = [];
                    }
                    parent.variations.push(item);
                    L2[item.id] = item;
                }
                else {
                    top.push(item);
                    L1[item.id] = item;
                }
            }
            else {
                top.push(item);
                L1[item.id] = item;
            }
        }
        /*
        for (let item of items) {
            if (item.parentId && item.parentId != item.id) {
                var parent = map[item.parentId];
                if (parent) {
                    if (!parent.variations) {
                        parent.variations = [];
                    }
                    parent.variations.push(item);
                } else {
                    result.push(item);
                }
            } else {
                result.push(item);
            }
        }
        */
        if (top.length != items.length) {
            this.log("processed variations", ig.name, items.length + "->" + top.length);
            this.log("L1", L1);
            this.log("L2", L2);
            this.log("parentItems", top);
        }
        ig.parentItems = top;
    };
    /**find out itemgroup's items' modifier groups**/
    MenuManager.prototype.checkIg = function (ig, gmap) {
        if (!ig.items)
            return;
        for (var _i = 0, _a = ig.items; _i < _a.length; _i++) {
            var item = _a[_i];
            this.checkMods(item, gmap);
        }
    };
    /**Check and push modifier groups**/
    MenuManager.prototype.checkMods = function (item, gmap) {
        var mgIds = item.mgroupIds;
        if (mgIds && mgIds.length > 0) {
            var mgs = [];
            for (var _i = 0, mgIds_1 = mgIds; _i < mgIds_1.length; _i++) {
                var mgId = mgIds_1[_i];
                var mg = gmap[mgId];
                if (mg)
                    mgs.push(mg);
                else {
                    this.log("missing mod ig", mgId);
                }
            }
            item.mgroups = mgs;
        }
    };
    /**
     * Get available category groups, by checking:
     * 1. if category groups is published
     * 2. available time slots or periods
     * **/
    MenuManager.prototype.getAvailableCategoryGroups = function (store, takeout) {
        var result = [];
        var now = this.getTime(store);
        if (!store || !store.menu) {
            return result;
        }
        var storeOpen = Store.isOpeningHours(store, now);
        if (!storeOpen)
            return result;
        var cats = store.menu.cgroups;
        if (!cats || cats.length == 0)
            return result;
        for (var _i = 0, cats_3 = cats; _i < cats_3.length; _i++) {
            var c = cats_3[_i];
            if (this.showAllCats) {
                result.push(c);
                continue;
            }
            //if not published, don't show it
            if (!c.published)
                continue;
            if (c.openings) {
                var brandOh = null;
                if (store.brand) {
                    brandOh = store.brand.openings;
                }
                if (!OpeningHours.isTimeOpen(brandOh, c.openings, now)) {
                    this.log("cat openings not available", c.name);
                    continue;
                }
            }
            else {
                //if category time not valid, don't show it
                if (!this.isAvailabeByStartEnd(c, now)) {
                    this.log("cat time not available", c.name);
                    continue;
                }
                if (!this.isAvailabeByPeriods(store, c.periods, now)) {
                    this.log("cat period not available2", c.name);
                    continue;
                }
            }
            result.push(c);
        }
        if (result.length != cats.length) {
            this.log("filtered cat groups", cats.length + "->" + result.length);
        }
        return result;
    };
    MenuManager.prototype.getAvailableRecommendations = function (store, recoms) {
        var now = this.convertNowDateToStoreTimeZone(store.timezone).getTime();
        var result = [];
        for (var _i = 0, recoms_1 = recoms; _i < recoms_1.length; _i++) {
            var rec = recoms_1[_i];
            var catAval = this.isAvailableCategory(store, rec.category, false, true);
            var itemAval = this.isAvailableItem(store, rec.category, rec.itemgroup, rec.item, false, now);
            if (catAval && itemAval) {
                result.push(rec);
            }
            else {
                this.log("Item Not Available", rec.item.name);
            }
        }
        return result;
    };
    var MenuManager_1;
    MenuManager.staticMenuMapForOh = {};
    MenuManager.device = null;
    MenuManager = MenuManager_1 = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [InventoryManager])
    ], MenuManager);
    return MenuManager;
}());
export { MenuManager };
//# sourceMappingURL=menu-manager.js.map